module.exports = __webpack_public_path__ + "static/media/live_costs_yellow-01.a2b5cb2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/live_costs_yellow-01.png
// module id = 779
// module chunks = 0